<div class="row">

  <!-- ============ Due Diligence campaign gate (shown before the reopen form) ============ -->
  <div class="col-12" [hidden]="IsFormVis">
    <div class="card card-secondary">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-8">
            <div class="form-check mb-3">
              Will this ICD be participating in any Due Diligence Campaigns? <code>*</code>
              <button type="button"
                      class="btn btn-sm btn-info ml-2"
                      title="View all due diligence campaigns"
                      (click)="showAllDueDiligenceCampaigns()">
                <i class="fa fa-info-circle"></i>
              </button>
              <br />
              <input type="radio" name="iSDueDel" value="Yes" id="iSDueDelYesRadio" [checked]="iSDueDelValue === 'Yes'" (change)="oniSDueDel('Yes')" class="form-check-input" />
              <label for="iSDueDelYesRadio" class="form-check-label">Yes</label><br />
              <input type="radio" name="iSDueDel" value="No" id="iSDueDelNoRadio" [checked]="iSDueDelValue === 'No'" (change)="oniSDueDel('No')" class="form-check-input" />
              <label for="iSDueDelNoRadio" class="form-check-label">No </label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-check mb-3">
              <button type="button"
                      *ngIf="IsDueDelVis && !Campaigns_isSelectedItemsinvalid && iSDueDelYes && selected_AccPo && selected_AccPoRep && campsdatafilter"
                      (click)="proceed()" class="btn btn-success float-right">
                Proceed
              </button>
            </div>
          </div>

          <div class="col-sm-4" *ngIf="iSDueDelYes && IsDueDelVis">
            <div class="form-group">
              <label class="col-form-label col-md-12" for="login-campaignName">Promoting Owner / Existing Owner <code>*</code></label>
              <div class="col-md-12">
                <input type="text" class="form-control" [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" placeholder="Enter Promoting Owner Name" (input)="filterOwners()">
              </div>
            </div>
            <span *ngIf="selected_camp" style="color:red;">Select Promoting Owner from below table</span>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Select</th>
                  <th>Owner Name</th>
                  <th>Owner Company</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let owner of filteredOwners">
                  <td><input type="radio" [value]="owner.id" (change)="onCheckbox_AccPO(owner)" [checked]="selected_AccPo === owner.ownerName"></td>
                  <td>{{ owner.ownerName }}</td>
                  <td>{{ owner.owner_Name_Company }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-sm-4" *ngIf="iSDueDelYes && selected_AccPo && IsDueDelVis">
            <label class="col-form-label col-md-12" for="login-Owner_Middle_Name"></label>
            <div class="form-group col-md-12">
              <div class="custom-control custom-switch custom-switch-on-success">
                <input type="checkbox" class="custom-control-input" id="isPOICDOCheckbox" [checked]="isPOICDNO" (change)="togglePOICDO($event)" />
                <label class="custom-control-label" for="isPOICDOCheckbox">Existing Owner Opening a New Corp</label>
              </div>
            </div>
            <span *ngIf="iSDueDelYes && !isPOICDNO" style="color:red;">Select New ICD Owner</span>
            <div class="form-group" *ngIf="!isPOICDNO">
              <label class="col-form-label col-md-12" for="login-campaignName">New ICD Owner <code>*</code></label>
              <div class="col-md-12">
                <ng-select [searchable]="true" [(ngModel)]="selected_AccPoRep"
                           [ngModelOptions]="{ standalone: true }" (change)="onCheckbox_AccPORep($event)">
                  <ng-option *ngFor="let o of getFilteredAccPoRep()"
                             [value]="o.icD_Rep_Name">
                    {{ o.icD_Rep_Name }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
          </div>

          <div *ngIf="iSDueDelYes && selected_AccPo && selected_AccPoRep && IsDueDelVis" class="col-md-4">
            <span style="color:red;" *ngIf="campsdatafilter && campsdatafilter.length">Select the Campaign</span><br />
            <span style="color:red;" *ngIf="!campsdatafilter || !campsdatafilter.length">No Campaign's available for selected Rep</span>
            <div class="col-md-12" *ngFor="let item of campsdatafilter">
              <div class="form-group">
                <div class="custom-control custom-switch custom-switch-on-success">
                  <input type="checkbox" class="custom-control-input" [id]="item.id" [checked]="Campaigns_selectedItems.includes(item.campaignName)"
                         [name]="'campaignSelection'" [value]="item.campaignName" (change)="onCheckboxChange_Campaigns($event, item.campaignName)">
                  <label class="custom-control-label" [for]="item.id">{{ item.campaignName + " ("+ item.name + ")" }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ============ /Due Diligence campaign gate ============ -->

  <form *ngIf="formResetToggle" [hidden]="!IsFormVis" class="login" name="loginForm"
        [formGroup]="icdForm" (ngSubmit)="onSubmit()" novalidate>
            <!-- general form elements disabled -->
            <div class="card card-secondary">
              <div class="card-header">
                <h3 class="card-title">ICD Information</h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">

                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-check mb-3">
                      <input type="radio" formControlName="US_or_CA" value="US" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />

                      <label for="acceptTerms" class="form-check-label">US</label><br />
                      <input type="radio" formControlName="US_or_CA" value="Canada" id="US_or_CA" (change)="onCountryChange()" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.US_or_CA.errors }" />
                      <label for="acceptTerms" class="form-check-label">Canada  <code>*</code></label>
                      <div *ngIf="submitted && f.US_or_CA.errors" class="invalid-feedback">US or Canada is required</div>
                    </div>
                  </div>

                </div>
                <div class="row">
                  <div class="col-sm-4">


                    <label class="col-form-label  col-md-12" for="login-Owner_First_Name">Owner's Legal First Name <code>*</code></label>
                    <input type="text" formControlName="Owner_First_Name" class="form-control"
                           [ngClass]="{'is-valid':  f.Owner_First_Name.valid, 'is-invalid' :submitted && f.Owner_First_Name.valid}" placeholder="Enter Owner Legal First Name"
                           appAiHint="Owner First Name" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Owner_First_Name.errors" class="invalid-feedback">
                      <div *ngIf="f.Owner_First_Name.errors.required">First Name is required</div>
                    </div>


                  </div>
                  <div class="col-sm-4">



                    <label class="col-form-label  col-md-12" for="login-Owner_Middle_Name">Owner's Legal Middle Name </label>
                   
                    <input type="text"  formControlName="Owner_Middle_Name" class="form-control"
                           placeholder="Enter Owner Legal Middle Name"
                           appAiHint="Owner Middle Name" [aiHintForm]="icdForm" />
                    <div *ngIf="submitted && f.Owner_Middle_Name.errors" class="invalid-feedback">
                      <div *ngIf="f.Owner_Middle_Name.errors.required">Middle Name is required</div>
                    </div>


                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">


                      <label class="col-form-label  col-md-12" for="login-Owner_Last_Name">Owner's Legal Last Name <code>*</code></label>
                      <input type="text" formControlName="Owner_Last_Name" class="form-control"
                             [ngClass]="{'is-valid': f.Owner_Last_Name.valid, 'is-invalid' : submitted && f.Owner_Last_Name.valid}" placeholder="Enter Owner Legal Last Name"
                             appAiHint="Owner Last Name" [aiHintForm]="icdForm" />
                      <div *ngIf="submitted && f.Owner_Last_Name.errors" class="invalid-feedback">
                        <div *ngIf="f.Owner_Last_Name.errors.required">Last Name is required</div>
                      </div>


                    </div>
                  </div>
                  <div class="row">

                    <div class="form-check mb-3">
                      Does Owner have a different preferred name ?  <code>*</code><br />

                      <input type="radio" value="Yes" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ" (change)="onIsPreferChange('Yes')" class="form-check-input" />
                      <label for="acceptTerms" class="form-check-label">Yes</label><br />
                      <input type="radio" value="No" formControlName="Is_Preferred_Differ" id="Is_Preferred_Differ" (change)="onIsPreferChange('No')" class="form-check-input" />
                      <label for="acceptTerms" class="form-check-label">No </label>

                    </div>

                    <div class="col-sm-4" *ngIf="IsPref_Differ">
                      <div class="form-group">

                        <label class="col-form-label  col-md-12" for="login-Owner_Preferred_First_Name">Preferred First Name <code>*</code></label>
                        <input type="text" formControlName="Owner_Preferred_First_Name" class="form-control"
                               placeholder="Enter Preferred First Name"
                               appAiHint="Owner Preferred First Name" [aiHintForm]="icdForm" />
                        <div *ngIf="submitted && f.Owner_Preferred_First_Name.errors" class="invalid-feedback">
                          <div *ngIf="f.Owner_Preferred_First_Name.errors.required">Preferred First Name is required</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4" *ngIf="IsPref_Differ">
                      <div class="form-group">

                        <label class="col-form-label  col-md-12" for="login-Owner_Preferred_Last_Name">Preferred Last Name <code>*</code></label>
                        <input type="text" formControlName="Owner_Preferred_Last_Name" class="form-control"
                               placeholder="Enter Preferred Last Name"
                               appAiHint="Owner Preferred Last Name" [aiHintForm]="icdForm" />
                        <div *ngIf="submitted && f.Owner_Preferred_Last_Name.errors" class="invalid-feedback">
                          <div *ngIf="f.Owner_Preferred_Last_Name.errors.required">Preferred Last Name is required</div>
                        </div>
                      </div>
                    </div>





                  </div>

                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">

                      <label class="col-form-label  col-md-12" for="login-Full_Legal_Company_Name">Full Legal Company Name <code>*</code></label>
                      <input type="text" formControlName="Full_Legal_Company_Name" class="form-control"
                             [ngClass]="{'is-valid': f.Full_Legal_Company_Name.valid, 'is-invalid' : submitted && f.Full_Legal_Company_Name.valid}" placeholder="Enter Full Legal Company Name"
                             appAiHint="Full Legal Company Name" [aiHintForm]="icdForm" />
                      <div *ngIf="submitted && f.Full_Legal_Company_Name.errors" class="invalid-feedback">
                        <div *ngIf="f.Full_Legal_Company_Name.errors.required">Full Legal Company Name  is required</div>
                      </div>

                    </div>
                  </div>
                  <div class="col-sm-4">

                    <div class="form-group">

                      <label class="col-form-label  col-md-12" for="login-Tax_ID">F.E.I.N. # (Tax ID)/Business # <code>*</code></label>
                      <input type="text" formControlName="Tax_ID" class="form-control" [attr.maxlength]="fieldMaxLengths.Tax_ID"
                             [ngClass]="{'is-valid': f.Tax_ID.valid, 'is-invalid' : submitted && !f.Tax_ID.valid}" placeholder="Enter  F.E.I.N. # (Tax ID)/Business" />
                      <div class="text-right small mt-1"
                           [ngClass]="{
         'text-danger': f.Tax_ID.errors?.maxlength,
         'text-muted': !f.Tax_ID.errors?.maxlength
       }">

                        {{ icdForm.get('Tax_ID')?.value?.length || 0 }}/{{ fieldMaxLengths.Tax_ID }}

                      </div>
                      <div *ngIf="submitted && f.Tax_ID.errors" class="invalid-feedback">
                        <div *ngIf="f.Tax_ID.errors.required">F.E.I.N. # (Tax ID)/Business #  is required</div>
                        <div *ngIf="f.Tax_ID.errors.maxlength">
                          Maximum {{ fieldMaxLengths.Tax_ID }} characters allowed
                        </div>
                      </div>


                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="form-group">

                      <label class="col-form-label  col-md-12" for="login-Owner_Email">Owner's Email <code>*</code></label>
                      <input type="text" formControlName="Owner_Email" class="form-control" [attr.maxlength]="fieldMaxLengths.Owner_Email"
                             [ngClass]="{'is-valid': f.Owner_Email.valid, 'is-invalid' : submitted && !f.Owner_Email.valid}" placeholder="Enter Owner's Email"
                             appAiHint="Owner Email" [aiHintForm]="icdForm" />
                      <div class="text-right small mt-1"
                           [ngClass]="{
                           'text-danger' : f.Owner_Email.errors?.maxlength,
                           'text-muted' : !f.Owner_Email.errors?.maxlength
                            }">
                        {{ icdForm.get('Owner_Email')?.value?.length || 0 }}/{{ fieldMaxLengths.Owner_Email }}
                      </div>
                      <div *ngIf="submitted && f.Owner_Email.errors" class="invalid-feedback">
                        <div *ngIf="f.Owner_Email.errors.required">Owner's Email  is required</div>
                        <div *ngIf="f.Owner_Email.errors.email">Email must be a valid email address</div>
                        <div *ngIf="f.Owner_Email.errors.maxlength">
                          Maximum {{ fieldMaxLengths.Owner_Email }} characters allowed
                        </div>
                        </div>


                    </div>
                  </div>

                  <div class="col-sm-4" *ngIf="selectedCountry == 'US'">

                    <div class="form-group">

                      <div class="col-md-12">
                        <label class="form-label">State of Incorporation <code>*</code></label>

                        <ng-select [searchable]="true" formControlName="State_of_Incorporation" [ngClass]="{'is-valid': f.State_of_Incorporation.valid, 'is-invalid' : submitted && !f.State_of_Incorporation.valid}">
                          <ng-option *ngFor="let o of ddlUSStates"
                                     [value]="o.value">
                            {{ o.name }}
                          </ng-option>
                        </ng-select>
                        <div *ngIf="submitted && f.State_of_Incorporation.errors" class="invalid-feedback">
                          <div *ngIf="f.State_of_Incorporation.errors.required">State of Incorporation is required</div>
                        </div>


                      </div>




                    </div>
                  </div>


                  <div class="col-sm-4" *ngIf="selectedCountry == 'Canada'">

                    <div class="form-group">

                      <div class="col-md-12">
                        <label class="form-label">Province of Incorporation <code>*</code></label>

                        <ng-select [searchable]="true" formControlName="Provinence_of_Incorporation" [ngClass]="{'is-valid': f.Provinence_of_Incorporation.valid, 'is-invalid' : submitted && !f.Provinence_of_Incorporation.valid}">
                          <ng-option *ngFor="let o of ddlCAProvinence"
                                     [value]="o.value">
                            {{ o.name }}
                          </ng-option>
                        </ng-select>
                        <div *ngIf="submitted && f.Provinence_of_Incorporation.errors" class="invalid-feedback">
                          <div *ngIf="f.Provinence_of_Incorporation.errors.required">Province Incorporation is required</div>
                        </div>


                      </div>




                    </div>
                  </div>

                  <div class="col-sm-4">

                    <div class="form-group">

                      <div class="col-md-12">

                        <label class="col-form-label  col-md-12" for="login-Date_of_Incorporation">Date of Incorporation <code>*</code></label>
                        <div class="input-group date" id="reservationdate" data-target-input="nearest">
                          <input type="text" formControlName="Date_of_Incorporation" data-target="#reservationdate" autocomplete="off"
                                 id="Date_of_Incorporation" placeholder="Select Date of Incorporation"
                                 class="form-control" [ngClass]="{'is-valid': submitted && f.Date_of_Incorporation.valid, 'is-invalid' : submitted && !f.Date_of_Incorporation.valid}"
                                 required
                                 />
                          <div class="input-group-append" style="pointer-events: none;" data-target="#reservationdate" data-toggle="datetimepicker">
                            <div class="input-group-text"><i class="fa fa-calendar"></i></div>
                          </div>
                          <div *ngIf="submitted && f.Date_of_Incorporation.errors" class="invalid-feedback">
                            <div *ngIf="f.Date_of_Incorporation.errors.required">Date of Incorporation is required</div>
                            <div *ngIf="f.Date_of_Incorporation.errors.pattern">Date of Incorporation must be a valid date in the format MM-DD-YYYY</div>
                            <div *ngIf="f.Date_of_Incorporation.errors.dateNotLessThanToday">Date of Incorporation cannot be less than today's date.</div>
                          </div>


                        </div>


                      </div>




                    </div>
                  </div>


                </div>
              </div>

            </div>
            <!-- /.card-body -->
            <!-- /.card -->
            <!-- general form elements disabled -->
            <div class="card card-secondary">
              <div class="card-header">
                <h3 class="card-title">HUB Information</h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-4">

                    <div class="form-group">
                      <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Name">Hub Name<code>*</code></label>
                      <div class="col-md-12">
                        <input  type="text" formControlName="HUB_Manager_Contact_Name"
                               id="login-HUB_Manager_Contact_Name" name="HUB_Manager_Contact_Name"
                               placeholder="Enter Manager Contact Name" autocomplete="HUB_Manager_Contact_Name"
                               class="form-control"
                               appAiHint="HUB Manager Contact Name" [aiHintForm]="icdForm" />

                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Number">Hub Number <code>*</code></label>
                      <div class="col-md-12">
                        <input formControlName="HUB_Manager_Contact_Number" type="text" id="login-HUB_Manager_Contact_Number" name="HUB_Manager_Contact_Number" placeholder="Enter Manager Contact Number"
                               autocomplete="current-Owner_Last_Name" class="form-control"
                               appAiHint="HUB Manager Contact Number" [aiHintForm]="icdForm" />

                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label class="col-form-label  col-md-12" for="login-HUB_Manager_Contact_Email">Hub Email <code>*</code></label>
                      <div class="col-md-12">
                        <input formControlName="HUB_Manager_Contact_Email" type="text" id="login-HUB_Manager_Contact_Email" name="HUB_Manager_Contact_Email" placeholder="Enter Manager Contact Email" autocomplete="current-HUB_Manager_Contact_Email"
                               class="form-control"
                               appAiHint="HUB Manager Contact Email" [aiHintForm]="icdForm" />

                      </div>
                    </div>
                  </div>

                </div>

                <!-- /.card-body -->
              </div>
            </div>

      <!-- AI Pre-Submit Review Modal -->
      <app-pre-submit-review
        [visible]="showPreSubmitReview"
        [issues]="preSubmitIssues"
        [loading]="preSubmitLoading"
        (dismiss)="onPreSubmitDismiss()"
        (submitAnyway)="onPreSubmitDoSubmit()"
        (recheck)="onPreSubmitRecheck()"
        (autoFix)="onPreSubmitAutoFix($event)"
        (navigateToField)="onPreSubmitNavigate($event)">
      </app-pre-submit-review>
            <div class="mb-3 row" *ngIf="btnDisplay">
              <div class="callout callout-info">
                <h6>***</h6>
                Upon clicking Submit, an email will be sent to the ICD Owner with a link to continue the onboarding process.
                <br />
               
                <button type="submit" class="btn btn-success float-right">
                  SUBMIT

                </button>


              </div>


            </div>
  </form>

</div>
